import React from "react";
import Grid from "@mui/material/Grid";

const statCardStyle = {
  padding: "8px 12px",
  borderRadius: "6px",
  backgroundColor: "#f5f5f5",
  textAlign: "center",
};

const numberStyle = {
  fontSize: "20px",
  fontWeight: "bold",
  margin: 0,
};

const labelStyle = {
  fontSize: "11px",
  color: "#666",
  margin: "2px 0 0 0",
};

const LeadStats = ({ stats }) => {
  if (!stats) return null;

  const emailInfo = stats.emailsToday || {};
  const emailLabel = emailInfo.limit
    ? `${emailInfo.sent || 0} / ${emailInfo.limit}`
    : `${emailInfo.sent || 0}`;
  const emailColor = emailInfo.canSend ? "#1976d2" : "#d32f2f";

  const cards = [
    { label: "US Leads", value: stats.total || 0, color: "#1976d2" },
    { label: "This Week", value: stats.thisWeekDiscovered || 0, color: "#2e7d32" },
    { label: "ICP A", value: stats.icpA || 0, color: "#2e7d32" },
    { label: "Need Website", value: stats.missingWebsite || 0, color: stats.missingWebsite ? "#ed6c02" : "#999" },
    { label: "Active Outreach", value: stats.activeOutreaches || 0, color: "#ed6c02" },
    { label: "Replied", value: stats.repliedCount || 0, color: "#9c27b0" },
    { label: "Sold", value: stats.soldCount || 0, color: "#2e7d32" },
    { label: "Bounced", value: stats.bouncedCount || 0, color: stats.bouncedCount > 0 ? "#d32f2f" : "#999" },
    { label: "Emails Today", value: emailLabel, color: emailColor },
  ];

  return (
    <Grid container spacing={1} style={{ marginBottom: "12px" }} wrap="nowrap">
      {cards.map((card) => (
        <Grid item xs key={card.label} style={{ minWidth: 0 }}>
          <div style={statCardStyle}>
            <p style={{ ...numberStyle, color: card.color }}>{card.value}</p>
            <p style={labelStyle}>{card.label}</p>
            {card.label === "Emails Today" && emailInfo.reason && (
              <p style={{ fontSize: "10px", color: "#d32f2f", margin: "2px 0 0 0", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {emailInfo.reason}
              </p>
            )}
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default LeadStats;
